module.exports = __webpack_public_path__ + "img/shop_hover.5ee37391.png";